import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Empty, Input} from 'antd'
import {useFormikContext} from "formik";
import {CardBody} from "reactstrap";
import apiClient from "services/axios";
import { withModalForm } from 'components/platform/hocs/Form'
import Field from 'components/platform/form/Field'
import Datepicker from 'components/platform/form/inputs/Datepicker'
import { renderDateTime } from 'components/platform/Table/renders'
import { ItemCodeSelect } from 'components/platform/form/inputs/ItemCodeSelect'
import AutocompleteCity from 'components/platform/form/inputs/AutocompleteCity'
import JAutocomplete from 'components/platform/form/inputs/JAutocomplete'
import Timepicker from 'components/platform/form/inputs/Timepicker'
import { VideoIcon } from "config/icons";
import {axiosErrorHandler} from "components/platform/utils";
import Switch from "components/platform/form/inputs/Switch";
import {Button} from "components/platform/buttons/Button";
import { MODAL_NAME } from 'config/modals';
import {useNavigator} from "components/platform/hocs/withNavigator";
import styles from './style.module.scss'
import AsyncSelect from "../../../../components/platform/form/inputs/AsyncSelect";
import {getIris} from "../../../../components/platform/utils";

const DateTimeView = () => <Input value={renderDateTime(new Date())} disabled />

const _setCity = (value: any) =>
  value == null
    ? {
        idProvince: '',
        place: '',
      }
    : {
        idProvince: value.prov || '',
        place: value.label,
      }

export const VtPlayer = ({ interviewId }: any) => {
  const [loading, setLoading] = React.useState(false)
  const [url, setUrl] = React.useState(null)

  const getUrl = () => {
    setLoading(true)
    apiClient.get(`/api/curriculum_interviews/${interviewId}/vt_links`).then(res => {
      setUrl(res.data.video_url)
      setLoading(false)
    }).catch((e) => {
      axiosErrorHandler(e)
      setLoading(false)
    })
  }

  return (url) ? (
    <div className={styles.interviewFrame}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video controls>
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    ):
    <div
      className={`${styles.emptyFrame}`}
      onClick={getUrl}
    >
      <Empty
        image={<VideoIcon style={{fontSize: 60}} />}
        imageStyle={{
          height: 50,
        }}
        description={loading ? "Loading...": <FormattedMessage id={'global.click_to_play'} />}
      />
    </div>
}

const InterviewModal = () => {
  const {values} = useFormikContext<any>()
  const modals = useNavigator()

  return (
    <CardBody>
      <div className="fg fg-3">
        <Field
          label={'candidati.it_interview_type'}
          name="interviewType"
          key={'interviewType'}
          component={ItemCodeSelect}
          type={'cv_interview'}
        />
        <div style={{ display: 'flex' }} key={'place'}>
          <div className={'mr-2'} style={{ flexBasis: '60%' }}>
            <Field
              label={'general.city'}
              component={AutocompleteCity}
              setValues={_setCity}
              itDetails
              name={'place'}
            />
          </div>
          <div style={{ flexBasis: '40%' }}>
            <Field label={'project.provincia'} name={'idProvince'} key={'idProvince'} />
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <Field
            label={'candidati.date'}
            name="interviewDate"
            key={'interviewDate'}
            component={Datepicker}
            className={`mr-2 ${styles.doubleField}`}
          />
          <Field
            label={'candidati.time'}
            name="interviewTime"
            key={'interviewTime'}
            component={Timepicker}
            className={styles.doubleField}
          />
        </div>
        <Field
          label={'progetti.responsabile'}
          name={'responsible'}
          key={'responsible'}
          component={JAutocomplete}
          source={'api/users'}
          getLabel={(i: any) => `${i.nome} ${i.cognome}`}
          obb
        />
        <Field label={'candidates.fonte'} name="source" disabled key={'source'} />
        <Field
          label={'candidati.date_and_time'}
          name="interviewDateTime"
          key={'interviewDateTime'}
          component={DateTimeView}
        />
        <Field
          label={'progetti.project'}
          name="projectCandidate"
          component={AsyncSelect}
          getLabel={({project:i}:any) => `${i.id} - ${i.group?.codiceGruppo || 'ND.'} - ${i.customer?.nome || 'ND.'} - ${i.titolo}`}
          source={`/api/project_candidates?curriculum=${  values.curriculum}`}
        />
        {values.projectCandidate && (
          <Field
            label={'global.visible_ac'}
            name="inDataroom"
            key={'inDataroom'}
            component={Switch}
          />
        )}
      </div>
      {/* SURVEY */}
      <div className='fg fg-3 mb-3'>
        <div className={`span3 ${styles.interviewCardSubHeader}`}>
          <FormattedMessage id={'global.interview'} />
          <div style={{ borderTop: "1px solid #ccc", margin: '0.5rem 0'}} />
        </div>
        <Field
          label={'survey.search_interview_template'}
          component={AsyncSelect}
          getLabel={(s: any) => `${s.code} - ${s.title}`}
          source={'/api/surveys'}
          name={'survey'}
          filter={'title'}
          className={'span2'}
        />
        {values.id > 0 && values.survey && (
          <div style={{ flexBasis: '40%', marginTop: '2rem' }}>
            <Button
              color='primary'
              onClick={() => {
                modals.open(MODAL_NAME.interviewStarted, {
                  itemId: values?.survey,
                  curriculumInterview: getIris(values)
                })
              }}
            >
              <FormattedMessage id='actions.run' />
            </Button>
          </div>
        )}
      </div>
      <div className="fg fg-3">
        <div className={`span3 ${styles.interviewCardSubHeader}`}>
          <FormattedMessage id={'candidati.summary_rating'} />
        </div>
        <Field
          label={'candidati.standard_contract'}
          name="contractType"
          key={'contractType'}
          component={ItemCodeSelect}
          type={'cv_contratto'}
        />
        <div style={{ display: 'flex' }}>
          <Field
            label={'candidati.business_cost'}
            name="businessCost"
            key={'businessCost'}
            className={`mr-2 ${styles.doubleField}`}
          />
          <Field
            label={'curriculum.expiry_date'}
            name="expiryDate"
            key={'expiryDate'}
            component={Datepicker}
            className={styles.doubleField}
          />
        </div>
        {values.vtInterviewStatus === "published" && (
          <div
            className={styles.videoFrame}
          >
            <VtPlayer interviewId={values.id} />
          </div>
        )}
        <Field label={'candidati.availability_notice'} name="advanceNotice" key={'advanceNotice'} />
        <Field label={'candidati.economic_demand'} name="salaryRequest" key={'salaryRequest'} />
        <Field
          label={'candidati.position'}
          name="position"
          key={'position'}
          component={ItemCodeSelect}
          type={'cvi_position'}
        />
        <Field
          label={'candidati.economic_proposal'}
          name="economicProposal"
          key={'economicProposal'}
        />
        <Field label={'candidati.accepts_proposal'} name="acceptance" key={'acceptance'} />
        <Field
          label={'candidati.reason_for_change'}
          name="motivation"
          key={'motivation'}
          component={'textarea'}
          className={'span2'}
        />
      </div>
    </CardBody>
  )
}

export default withModalForm({
  apiResource: 'api/curriculum_interviews',
  title: ({ item }: any) =>
    item?.id ? (
      <FormattedMessage id={'interviews.edit'} />
    ) : (
      <FormattedMessage id={'interviews.new'} />
    ),
  width: 1270,
  buttons: {
    saveButton: true,
    // @ts-ignore
    saveCloseButton: false,
    saveButtonLabel: true,
    saveContinueText: 'global.save',
    cancelText: <FormattedMessage id={'global.close'} />,
  },
} as any)(InterviewModal)
